import { FC } from 'react';

import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';

type Props = IconButtonProps & {
  loading?: boolean;
};

const LoadingIconButton: FC<Props> = props => {
  const { children, loading = false, ...rest } = props;

  return (
    <IconButton {...rest}>
      {loading ? <CircularProgress size="1rem" /> : children}
    </IconButton>
  );
};

export default LoadingIconButton;
